import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';
// import axios from 'axios';


// components
import Calendar from '../components/singlets/Calendar';

class Page extends Component {
  state = {
    months: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]
  }

  slideToMonth() {
    // console.log(this);
    let form = document.getElementById(this);
    const y = form.offsetTop - 75;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }

  render() {
    const { months } = this.state;

    return (
      <>
        <div className="calendar">
          <div className="container">
            <div className="row">

              {/* <div className="col-12 breadcrumbs">
                <a href="https://www.usa.edu/">Home</a> &nbsp; &gt; &nbsp; Diversity and Inclusion Calendar
              </div> */}

              <div className="col-8 content">
                <h1>Diversity and Cultural Awareness Calendar</h1>
                <p>This calendar promotes widely recognized awareness months, days and celebrations across cultures and for specific groups or causes. This diversity and cultural awareness calendar serves as an educational opportunity to help bring us together as One University.</p>

                <p>If you would like to add a special date or commemorative month to the calendar, please email it to <a href="mailto:IDEA@usa.edu" className="strong">IDEA@usa.edu</a>. Include any corresponding details and/or links that could be helpful in building awareness of the event and its significance.</p>

                <p><i>NOTE: This calendar listing is intended to provide information about the named cultural/religious observation and is not intended as an actual campus event.</i></p>

                <div className="mobileButtons">
                  <h2>Select a month to jump to that months events</h2>

                  {months.map((m, key) =>
                    <button data-month={ m.toLowerCase() } key={ key } onClick={ this.slideToMonth.bind(m) }>{ m }</button>
                  )}
                </div>

                {months.map((m, key) =>
                  <Calendar month={ m } key={ key } />
                )}

              </div>

              <div className="col-4 sidebar">
                <div className="sideCont">
                  <h2>Select a month to jump to that months events</h2>

                  {months.map((m, key) =>
                    <button data-month={ m.toLowerCase() } key={ key } onClick={ this.slideToMonth.bind(m) }>{ m }</button>
                  )}

                  {/* <hr />

                  <h2>USAHS blogs about diversity and inclusion</h2>
                  <div className="blogPost">
                    <a href="https://www.usa.edu/blog/student-associations-cotad-and-speak-promote-diversity/" target="_blank" rel="noopener noreferrer">
                      <img src="https://www.usa.edu/wp-content/uploads/2022/07/Rasberry-front-left-and-COTAD-St.-Augustine-on-a-Field-Day-nlog.jpg" alt="Student Associations COTAD and SPEAK Promote Diversity" />
                      Student Associations COTAD and SPEAK Promote Diversity
                    </a>
                  </div>

                  <div className="blogPost">
                    <a href="https://www.usa.edu/blog/searching-for-equity-the-librarys-lgbtqia2-resources/" target="_blank" rel="noopener noreferrer">
                      <img src="https://www.usa.edu/wp-content/uploads/2022/05/USAHS-LGBTQ-hero.jpg" alt="Searching for Equity: The Library's LGBTQIA2+ Resources" />
                      Searching for Equity: The Library's LGBTQIA2+ Resources
                    </a>
                  </div> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Page;